import { registerLocaleData } from '@angular/common';
import { HttpClientModule, HTTP_INTERCEPTORS } from '@angular/common/http';
import localeFrExtra from '@angular/common/locales/extra/fr';
import localeFr from '@angular/common/locales/fr';
import { APP_INITIALIZER, NgModule } from '@angular/core';
import { AngularFireModule } from '@angular/fire';
import { AngularFireAuthModule } from '@angular/fire/auth';
import { ReactiveFormsModule } from '@angular/forms';
import { BrowserModule, BrowserTransferStateModule, Meta } from '@angular/platform-browser';
import { BrowserAnimationsModule } from '@angular/platform-browser/animations';
import { NgbModule } from '@ng-bootstrap/ng-bootstrap';
// import { TransferHttpCacheModule } from '@nguniversal/common';
import { TranslateModule } from '@ngx-translate/core';
import { MessageService } from 'primeng/api';
import { DialogService, DynamicDialogRef } from 'primeng/dynamicdialog';
import { environment } from 'src/environments/environment';
import { AppRoutingModule } from './app-routing.module';
import { AppComponent } from './app.component';
import { CoreModule } from './modules/core/core.module';
import { Error404PageComponent } from './modules/pages/components/error404-page/error404-page.component';
import { AuthGuard } from './shared/guards/auth.guard';
import { TokenInterceptor } from './shared/interceptors/token.interceptor';
import { LayoutsModule } from './shared/modules/layouts.module';
import { SharedModule } from './shared/shared.module';
import { initIndexing } from './utils/seo.util';
import { MaintenanceInterceptor } from './shared/interceptors/maintenance.interceptor';
import { SiteAdminService } from './services/site-admin.service';
import { StoreModule } from '@ngrx/store';
import { generalSettingsReducer } from './store/general-settings/general-settings.reducer';
import { StoreReducers } from './store';
import { RecaptchaModule } from "ng-recaptcha";

registerLocaleData(localeFr, 'fr', localeFrExtra);

@NgModule({
  declarations: [AppComponent, Error404PageComponent],
  imports: [
    BrowserModule.withServerTransition({ appId: 'ssrui' }),
    TranslateModule.forRoot({
      defaultLanguage: 'en',
    }),
    StoreModule.forRoot(StoreReducers),
    AppRoutingModule,
    RecaptchaModule,
    LayoutsModule,
    SharedModule,
    BrowserAnimationsModule,
    NgbModule,
    AngularFireAuthModule,
    AngularFireModule.initializeApp(environment.firebase),
    CoreModule,
    ReactiveFormsModule,
    HttpClientModule,
    BrowserTransferStateModule,
  ],
  entryComponents: [],
  providers: [
    AuthGuard,
    SiteAdminService,
    MessageService,
    DialogService,
    DynamicDialogRef,
    { provide: HTTP_INTERCEPTORS, useClass: TokenInterceptor, multi: true },
    {
      provide: HTTP_INTERCEPTORS,
      useClass: MaintenanceInterceptor,
      multi: true,
    },
    // {
    //   provide: ErrorHandler,
    //   useClass: SentryErrorHandler,
    // },
    // {
    //   provide: Sentry.TraceService,
    //   deps: [Router],
    // },
    {
      provide: APP_INITIALIZER,
      useFactory: () => () => {},
      // deps: [Sentry.TraceService],
      multi: true,
    },

    {
      provide: APP_INITIALIZER,
      useFactory: initIndexing,
      multi: true,
      deps: [Meta],
    },
  ],
  bootstrap: [AppComponent],
})
export class AppModule {}

